import React from 'react';

import { Title, Text } from '@soluto-design/react';

import cls from '@soluto-design/styles/cls';

interface ContentProps {
    icon?: string;
    title: string;
    description?: string;
}

const Content = ({ icon, title, description }: ContentProps) => {
    return (
        <div className="flex flex-col">
            {icon && (
                <div className="flex mb-24 h-32 w-32">
                    <img src={icon} alt="icon" loading="lazy" />
                </div>
            )}
            <Title
                className={cls('text-b400 text-text-primary !font-semibold')}>
                {title}
            </Title>

            {description && (
                <Text
                    component="div"
                    isHtml
                    className={cls(
                        'text-b400 text-text-secondary font-regular pt-8',
                    )}>
                    {description}
                </Text>
            )}
        </div>
    );
};

export default Content;
